// extracted by mini-css-extract-plugin
module.exports = {"badge":"gift-quantity-badge_badge__XZ1NU"};